module.exports = __webpack_public_path__ + "static/img/case_5.2196811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_5.jpg
// module id = JHE9
// module chunks = 0